import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {menu_collapsible_template} from "../templates/menu_collapsible_template";

declare var ko: any;

export class mainMenu_template extends vnTemplate{

    public menu: menu_collapsible_template;

    protected getTemplateHtml(): string{

        return `
        <!-- Hidden checkbox to control the menu -->
        <input type="checkbox" id="menu-toggle" />

        <!-- Hamburger menu icon -->
        <label for="menu-toggle" class="hamburger" data-bind="visible: isVisible">
            <i class="icon i-hamburger"></i>
        </label>
        <div class="hamburger-menu-wrapper">
            <label for="menu-toggle" class="hamburger in-menu">
                <span></span>
                <span></span>
                <span></span>
            </label>
            <div class="main-nav" >
                <h1 class="site-logo mobile-only" style="display: none"><a href="/" ></a></h1>
                ` + this.menu.getHtmlBuild() + `
            </div>
        </div>
        `;
    }

    protected getTemplateName(): string{
        return "mainMenu-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected initPartial(): void {

        this.menu = new menu_collapsible_template("menu", this.getTemplateViewModel(), this.caller);
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            isVisible: ko.observable(false),
            isLoading: ko.observable(0)
        };

    }

    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public setMenus(menus){

        this.menu.setMenus(menus);
        if (menus.length > 0){

            this.getTemplateViewModel().isVisible(true);
        }else {

            this.getTemplateViewModel().isVisible(false);
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/mainMenu_template.ts